module.exports = __webpack_public_path__ + "static/media/Link.91763b54.svg";